import { notifications } from "@mantine/notifications"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { queryKeys, updateAPICompany } from "@/utils"

export function useCompanySettings() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateAPICompany,
    onSuccess: (data) => {
      notifications.show({
        color: "green",
        title: t("Success"),
        message: t("Settings updated"),
      })
      queryClient.setQueryData(queryKeys.auth, (oldData: any) => ({
        ...oldData,
        company: data,
      }))
    },
  })
}
